import React from 'react';
import './Breadcrumb.css';

/**
 * Reusable Breadcrumb component for consistent navigation across the app.
 *
 * @param {Object} props
 * @param {Array<{label: string, onClick?: function}>} props.items
 *   Array of breadcrumb items. The last item is automatically styled as active.
 *   Items with an `onClick` handler are rendered as clickable links.
 *
 * Usage:
 *   <Breadcrumb items={[
 *     { label: 'Home', onClick: () => navigate('/') },
 *     { label: 'Reports', onClick: () => navigate('/reports') },
 *     { label: 'Tranche' }
 *   ]} />
 */
const Breadcrumb = ({ items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="ds-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            <span
              className={`ds-breadcrumb-item ${isLast ? 'ds-breadcrumb-active' : ''} ${item.onClick && !isLast ? 'ds-breadcrumb-link' : ''}`}
              onClick={!isLast && item.onClick ? item.onClick : undefined}
              role={!isLast && item.onClick ? 'link' : undefined}
              tabIndex={!isLast && item.onClick ? 0 : undefined}
            >
              {item.label}
            </span>
            {!isLast && <span className="ds-breadcrumb-separator">{'>'}</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
